import { AnchorLink } from 'components/anchorLink';
import { CardAppIcon } from 'components/cardAppIcon';
import { DashboardCms } from 'lib/datoCms/queries/getDashboardPage';
import { Wrapper } from 'components/wrapper';
import styles from './AppCenter.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useMemo } from 'react';

export type AppCenterProps = {
  leNostreApp: NonNullable<DashboardCms['leNostreAppBlock']>;
};
export const AppCenter = ({ leNostreApp }: AppCenterProps) => {
  const MAX_APP = 8;

  const labelVediTutte = useGetLabelByKey('vedi-tutte')!;
  const appList = useMemo(() => {
    return leNostreApp[0].appList
      .map((app) => {
        return {
          image: {
            alt: '',
            src: app.logo.url,
          },
          heroImage: app.banner
            ? {
                alt: '',
                src: app.banner.url,
              }
            : null,
          urlDonwloadAppIos: app?.linkIos?.[0]?.href ?? null,
          urlDonwloadAppAndroid: app?.linkAndroid?.[0]?.href ?? null,
          urlDonwloadAppAndroidLabel: app.versione,
          description: app.description,
        };
      })
      .slice(0, MAX_APP);
  }, [leNostreApp]);

  return (
    <Wrapper
      classNameWrapper={styles.marginTop}
      noPaddingTop={true}
      noPaddingBottom
      borderRadius
      noPaddingLeft={true}
      noPaddingRight={true}
    >
      <div className={styles.header}>
        <span className={styles.title}>{leNostreApp[0].title}</span>
      </div>
      <div className={styles.appList}>
        {appList?.map((app) => {
          return <CardAppIcon key={app.image.src} image={app.image} className={styles.sizeImage} />;
        })}
      </div>
      {!!leNostreApp[0].urlAppPage?.length && leNostreApp[0].appList?.length! > MAX_APP && (
        <AnchorLink href={leNostreApp?.[0].urlAppPage[0].href} className={styles.href}>
          {labelVediTutte}
        </AnchorLink>
      )}
    </Wrapper>
  );
};
